import type {
  SupplierRelationshipProductItemDiscountCreateRequestType,
  SupplierRelationshipProductItemDiscountCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierRelationshipProductItemDiscountCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (
      data: SupplierRelationshipProductItemDiscountCreateRequestType,
    ) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `supplier-relationship-product-item-discounts`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierRelationshipProductItemDiscountCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierRelationshipProductItemDiscounts,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
    },
  });
};
